import { render, staticRenderFns } from "./SourceForm.vue?vue&type=template&id=0c46a1aa&scoped=true"
import script from "./SourceForm.vue?vue&type=script&lang=js"
export * from "./SourceForm.vue?vue&type=script&lang=js"
import style0 from "./SourceForm.vue?vue&type=style&index=0&id=0c46a1aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c46a1aa",
  null
  
)

export default component.exports